import { useState } from 'react';
import { Braces, Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

interface Props {
  data: unknown;
  label?: string;
  variant?: 'button' | 'icon';
  size?: 'sm' | 'default';
}

export function JsonToggle({ data, label = 'Ver JSON', variant = 'button', size = 'sm' }: Props) {
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(data, null, 2);

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard pode falhar em http; ignora */
    }
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        {variant === 'icon' ? (
          <Button variant="ghost" size="sm" title={label}>
            <Braces className="h-4 w-4" />
          </Button>
        ) : (
          <Button variant="outline" size={size}>
            <Braces className="h-4 w-4 mr-1" /> {label}
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle>JSON</DialogTitle>
            <Button variant="outline" size="sm" onClick={copyToClipboard} className="mr-6">
              {copied ? <Check className="h-4 w-4 mr-1" /> : <Copy className="h-4 w-4 mr-1" />}
              {copied ? 'Copiado!' : 'Copiar'}
            </Button>
          </div>
        </DialogHeader>
        <pre className="text-xs bg-muted rounded p-3 overflow-auto max-h-[70vh] font-mono whitespace-pre-wrap">
          {json}
        </pre>
      </DialogContent>
    </Dialog>
  );
}
